/**
 * F-LR-057 (2026-10-08 prod rehearsal): a paying agent's statement read by the deterministic reader is scored by
 * checks on what it says. The model's data-quality score grades every ABF document against one generic field list
 * (servicer, pool, covenants) and gave an exact statement 50%.
 */
export function payingAgentStatementChecks(abf: any): { label: string; passed: boolean }[] | null {
  if (!abf || abf.statement_source !== 'PRINTED_STATEMENT') return null;
  const lines: any[] = Array.isArray(abf.lines) ? abf.lines : [];
  const n = (v: any) => (v === null || v === undefined || v === '' || Number.isNaN(Number(v)) ? null : Number(v));
  const total = lines.reduce((sum, l) => sum + Number(l.amount || 0), 0);
  const available = n(abf.available_collections);
  const distributed = n(abf.distribution_total);
  const principal = n(abf.lender_principal);
  const interest = n(abf.lender_interest);
  return [
    { label: 'Lines foot to available collections', passed: available != null && lines.length > 0 && Math.abs(total - available) < 0.005 },
    { label: 'Principal + interest = distributed to the lender', passed: distributed != null && principal != null && interest != null && Math.abs(principal + interest - distributed) < 0.005 },
    { label: 'Collection period and payment date stated', passed: Boolean(abf.collection_period) && Boolean(abf.payment_date) },
    { label: 'Every line cites its page', passed: lines.length > 0 && lines.every(l => l.source_page != null && l.source_page !== '') },
    { label: 'Printed statement and appendix agree', passed: !(Array.isArray(abf.statement_conflicts) && abf.statement_conflicts.length > 0) },
  ];
}
